import { isOneclickUser } from 'app/policies/config';
import { PATH_TOOLS } from 'app/router/routesConfigTools';

export function tools(path, user) {
  if (PATH_TOOLS === path) {
    return isOneclickUser(user);
  }

  return true;
}
